import { SavedItinerary } from '@/components/itinerary/SavedItinerary';

export default function SavedItineraryPage() {
  return <SavedItinerary />;
}
